module.exports = __webpack_public_path__ + "media/images/pc/brands/aqua/store_tachikawa-4f40a71002ba885834d4d4d63ae2ea98.jpg";